export type User = {
  id: number
  nik: string
  phoneNumber: string
  fullName: string
  accountNumber: string
  joinDate: string
  kycStatus: string
}

export type ResponseUser = {
  id: number
  contact_no: string
  full_name: string
  NRIC: string
  created_at: string
  kyc_status: string
  account_number: string
}

export type Transaction = {
  id: number
  date: string
  status: string
  type: string
  amount: string
  details: string
}

export type ResponseTransaction = {
  id: number
  created_at: string
  status: string
  type: string
  amount: string
  description: string
}

export enum MERCHANT_USER_DETAILS_ACTIONS {
  SET_USER = 'MERCHANT_USER_DETAILS_ACTIONS.SET_USER',
  SET_IS_USER_LOADING = 'MERCHANT_USER_DETAILS_ACTIONS.SET_IS_USER_LOADING',
  SET_TRANSACTIONS_OF_USERS = 'MERCHANT_USER_DETAILS_ACTIONS.SET_TRANSACTIONS_OF_USERS',
  SET_IS_TRANSACTION_TABLE_LOADING = 'MERCHANT_USER_DETAILS_ACTIONS.SET_IS_TRANSACTION_TABLE_LOADING',
  SET_FILTERS = 'MERCHANT_USER_DETAILS_ACTIONS.SET_FILTERS',
  RESET_TRANSACTIONS = 'MERCHANT_USER_DETAILS_ACTIONS.RESET_TRANSACTIONS',
  RESET_CURRENT_PAGE = 'MERCHANT_USER_DETAILS_ACTIONS.RESET_CURRENT_PAGE',
}

type SetUser = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.SET_USER
  currentUser: User
  isUserLoading: boolean
}

type SetIsUserLoading = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.SET_IS_USER_LOADING
  isUserLoading: boolean
}

type SetUsersTransactions = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.SET_TRANSACTIONS_OF_USERS
  userTransactions: Transaction[]
  totalTransactions: number
}

type SetIsTransactionTableLoading = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.SET_IS_TRANSACTION_TABLE_LOADING
  isTransactionTableLoading: boolean
}

type SetFilters = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.SET_FILTERS
  filterKey: string
  filterValues: string | number
}

type ResetTransactions = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.RESET_TRANSACTIONS
}

type ResetCurrentPage = {
  type: typeof MERCHANT_USER_DETAILS_ACTIONS.RESET_CURRENT_PAGE
}

export type ActionTypes =
  | SetUser
  | SetIsUserLoading
  | SetUsersTransactions
  | SetIsTransactionTableLoading
  | SetFilters
  | ResetTransactions
  | ResetCurrentPage
